import React from 'react';

import { Form, SonForm, useForm } from '../../Form2';
import { Form2Modifier } from '../../Form2/Form';
import { InteractionStatus } from '../../../types/InteractionStatus';
import { MicroInteractionButton } from '../../../components/molecules/MicroInteractionButton/MicroInteractionButton';
import { BtnModifier } from '../../../components/molecules/Btn';
import { Icons } from '../../../components/atoms/SVG';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';

export const ParticipationStatus = {
  PARTICIPATING: 'PARTICIPATING',
  NOT_PARTICIPATING: 'NOT_PARTICIPATING',
};

type ParticipationButtonProps = {
  form: SonForm<any>;
  participating: boolean;
  onSuccess: () => void;
};

export function ParticipationButton({ form, participating, onSuccess }: ParticipationButtonProps) {
  const { t } = useSonTranslation('ParticipationButton');

  const { formProps, fetchState } = useForm({
    form,
    onSuccess: onSuccess,
  });

  const getCurrentInteraction = () => {
    if (fetchState.type === 'loading') {
      return InteractionStatus.SENDING;
    }
    if (fetchState.type === 'error') {
      return InteractionStatus.FAIL;
    }
    return participating ? ParticipationStatus.PARTICIPATING : ParticipationStatus.NOT_PARTICIPATING;
  };

  const currentInteraction = getCurrentInteraction();

  return (
    <Form modifier={Form2Modifier.NO_PADDING} {...formProps}>
      <MicroInteractionButton
        type="submit"
        modifier={[BtnModifier.MICRO_INTERACTION, BtnModifier.TRANSPARENT, BtnModifier.MINOR_ACTION]}
        svgSpriteId={Icons.PARTICIPATE}
        hiddenText
        text={t('button.accept')}
        titleText={t('button.accept')}
        tooltipPlacement={TooltipPlacement.TOP}
        currentInteraction={currentInteraction}
        interactions={{
          [ParticipationStatus.NOT_PARTICIPATING]: {
            svgSpriteId: Icons.PARTICIPATE,
            modifier: [BtnModifier.MICRO_INTERACTION, BtnModifier.TRANSPARENT, BtnModifier.MINOR_ACTION],
            text: t('button.accept'),
            titleText: t('button.accept'),
          },
          [ParticipationStatus.PARTICIPATING]: {
            svgSpriteId: Icons.PARTICIPATE,
            modifier: [
              BtnModifier.MICRO_INTERACTION,
              BtnModifier.TRANSPARENT,
              BtnModifier.MINOR_ACTION,
              BtnModifier.MINOR_ACTION_ACTIVATED,
              BtnModifier.MINOR_ACTION_ACTIVATED_GREEN,
            ],
            text: t('button.decline'),
            titleText: t('button.decline'),
          },
          [InteractionStatus.FAIL]: {
            svgSpriteId: Icons.FEEDBACK_ERROR,
            modifier: [
              BtnModifier.MICRO_INTERACTION,
              BtnModifier.TRANSPARENT,
              BtnModifier.MINOR_ACTION,
              BtnModifier.MINOR_ACTION_FAILED,
            ],
            text: t('form.failure.statusMessage'),
            titleText: t('form.failure.statusMessage'),
          },
          [InteractionStatus.SENDING]: {
            modifier: [
              BtnModifier.MICRO_INTERACTION,
              BtnModifier.TRANSPARENT,
              BtnModifier.MINOR_ACTION,
              BtnModifier.MINOR_ACTION_BUSY,
            ],
            text: t('form.status.sending'),
            titleText: null,
          },
        }}
      />
    </Form>
  );
}
